/**
 * Environment constants
 */
export const PRODUCTION_ENVIRONMENT = 'Production'
export const SANDBOX_ENVIRONMENT    = 'Sandbox'
export const DEFAULT_ENVIRONMENT    = PRODUCTION_ENVIRONMENT
